import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { PageResponse, MasteryLevel, QueueStatus, Key, Form, TimeSignature, Instrument, AssessmentLevel } from '@/lib/types';

export function useMasteryLevels(): ReturnType<typeof useQuery<PageResponse<MasteryLevel>>> {
  return useQuery({
    queryKey: ['mastery-levels'],
    queryFn: () => api.fetch<PageResponse<MasteryLevel>>('/mastery-levels?size=100'),
    staleTime: Infinity,
  });
}

export function useQueueStatuses(): ReturnType<typeof useQuery<PageResponse<QueueStatus>>> {
  return useQuery({
    queryKey: ['queue-statuses'],
    queryFn: () => api.fetch<PageResponse<QueueStatus>>('/queue-statuses?size=100'),
    staleTime: Infinity,
  });
}

export function useKeys(): ReturnType<typeof useQuery<PageResponse<Key>>> {
  return useQuery({
    queryKey: ['keys'],
    queryFn: () => api.fetch<PageResponse<Key>>('/keys?size=100'),
    staleTime: Infinity,
  });
}

export function useForms(): ReturnType<typeof useQuery<PageResponse<Form>>> {
  return useQuery({
    queryKey: ['forms'],
    queryFn: () => api.fetch<PageResponse<Form>>('/forms?size=100'),
    staleTime: Infinity,
  });
}

export function useTimeSignatures(): ReturnType<typeof useQuery<PageResponse<TimeSignature>>> {
  return useQuery({
    queryKey: ['time-signatures'],
    queryFn: () => api.fetch<PageResponse<TimeSignature>>('/time-signatures?size=100'),
    staleTime: Infinity,
  });
}

export function useInstruments(): ReturnType<typeof useQuery<PageResponse<Instrument>>> {
  return useQuery({
    queryKey: ['instruments'],
    queryFn: () => api.fetch<PageResponse<Instrument>>('/instruments?size=100'),
    staleTime: Infinity,
  });
}

export function useAssessmentLevels(): ReturnType<typeof useQuery<PageResponse<AssessmentLevel>>> {
  return useQuery({
    queryKey: ['assessment-levels'],
    queryFn: () => api.fetch<PageResponse<AssessmentLevel>>('/assessment-levels?size=10'),
    staleTime: Infinity,
  });
}

export function useGenres(): ReturnType<typeof useQuery<PageResponse<{ genreId: string; prettyName: string; canonicalName: string }>>> {
  return useQuery({
    queryKey: ['genres'],
    queryFn: () => api.fetch<PageResponse<{ genreId: string; prettyName: string; canonicalName: string }>>('/genres?size=100'),
    staleTime: Infinity,
  });
}
